import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/lib/utils';

export type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
  label?: string;
  thumbClassName?: string;
};

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
  ({ className, label, thumbClassName, ...props }, ref) => (
    // biome-ignore lint/a11y/noLabelWithoutControl: ignored
    <label className={cn('inline-flex', label && 'cursor-pointer items-center gap-[21px]')}>
      <SwitchPrimitives.Root
        className={cn(
          'peer inline-flex h-[22px] w-[49px] shrink-0 cursor-pointer items-center rounded-full border-[2px] border-primary-light shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-light data-[state=unchecked]:bg-background-darker',
          className
        )}
        {...props}
        ref={ref}
      >
        <SwitchPrimitives.Thumb
          className={cn(
            'pointer-events-none block h-[20px] w-[20px] rounded-full border-[2px] border-primary-light bg-primary-lighter shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-[26px] data-[state=unchecked]:translate-x-[-1px]',
            thumbClassName
          )}
        />
      </SwitchPrimitives.Root>
      {label && <span className={cn('select-none text-sm text-primary-dark')}>{label}</span>}
    </label>
  )
);

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
